import { type Platform, PLATFORM_NAMES } from '@/features/calendar/platforms';
import { formatViews } from '@/features/media/library';

const DAY_MS = 24 * 60 * 60 * 1000;

/** "3.4×" - one decimal under 10, whole numbers above. */
export const formatLift = (lift: number) =>
  `${lift >= 10 ? Math.round(lift) : lift.toFixed(1).replace(/\.0$/, '')}×`;

/** "today", "yesterday", "3d ago". */
export function postedAgo(iso: string | null, now: number) {
  if (!iso) return null;
  const days = Math.max(0, Math.floor((now - new Date(iso).getTime()) / DAY_MS));
  return days === 0 ? 'today' : days === 1 ? 'yesterday' : `${days}d ago`;
}

export const platformName = (platform: string) =>
  PLATFORM_NAMES[platform.toLowerCase() as Platform] ?? platform;

/** "12.3K" or "-" when not reported. */
export const views = (value: number | null) =>
  value === null ? '-' : formatViews(value);
